export default "/js/fonts/f1fd2824f6c602ce2f26120c54953273.ttf";